import React, { memo, useCallback, useMemo, useRef } from 'react';
import { Button, SelectWrapper } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { ensureRoute } from 'utils/routes';

const AutomationsCreateMenu = memo(({ openBuilder }) => {
    const buttonCreateRef = useRef();

    const clickMenu = useCallback(
        (value) => {
            if (value.value === 'create') openBuilder();
            if (value.value === 'templates') ensureRoute('/settings/automations/templates');
            buttonCreateRef.current?.click();
        },
        [openBuilder],
    );

    const options = useMemo(() => {
        return [
            {
                label: getLiteral('action_automation_create_from_template'),
                value: 'templates',
            },
            { label: getLiteral('action_automation_create'), value: 'create' },
        ];
    }, []);

    return (
        <SelectWrapper
            options={options}
            onChange={clickMenu}
            classes={{ Popover: 'fm-automations-settings__toolbar-popover' }}
        >
            <Button ref={buttonCreateRef}>{getLiteral('action_create')}</Button>
        </SelectWrapper>
    );
});

export default AutomationsCreateMenu;
